<template>
	<div class="news-page">

		<!-- ===== 主卡片 ===== -->
		<div class="main-card animate__animated  ">

			<!-- 标题 -->
			<div class="card-title-row">
				<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30871_10242/24.svg')"></el-image>
				<h3 class="title-text">{{$t('userPageL.txt10')}}</h3>
			</div>

			<!-- 通知列表 -->
			<div class="notice-list">
				<div v-for="(item, idx) in noticeList" :key="idx" class="notice-card">
					<div class="notice-icon-wrap">
						<el-image class="icon-ring" :src="iconRing"></el-image>
						<el-image class="icon-inner" :src="iconInner"></el-image>
					</div>
					<div class="notice-body">
						<div class="notice-header">
							<div class="notice-title-row">
								<span class="notice-title">{{ item.noticeTitle }}</span>
							</div>
							<span class="notice-time">{{ item.createTime }}</span>
						</div>
						<p class="notice-desc" v-html="item.noticeContent"></p>
					</div>
				</div>
			</div>
				
		</div>
			
	</div>
</template>

<script>
import {
	noticelist,
} from "/src/api/api.js"
export default {
	name: 'MyNews',
	data() {
		return {
			noticeList: [],
			iconRing: require('@/static/CodeBuddyAssets/30871_10242/31.svg'),
			iconInner: require('@/static/CodeBuddyAssets/30871_10242/32.svg'),
		}
	},
	mounted() {
		this.pageslist()
	},
	methods: {
		// 列表
		async pageslist(){
			var res;
			res = await noticelist({});
			if(res.code==200){
				this.noticeList = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
}
</script>

<style lang="scss" scoped>
.news-page {
	width: 100%;
	box-sizing: border-box;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 22px;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.crumb-text {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin-left: 8px;
}
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	span {
		font-size: 16px;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 8px;
		height: 12px;
		margin-left: 6px;
	}
}

/* ===================================================================
   主卡片 (1596×442px)
   =================================================================== */
.main-card {
	width: 1596px;
	background: #fff;
	border-radius: 12px;
	padding: 24px 24px 32px;
	box-sizing: border-box;
	margin-top: 24px;
}

/* ---- 标题 ---- */
.card-title-row {
	display: flex;
	align-items: center;
	height: 28px;
	margin-bottom: 24px;
}
.title-icon {
	width: 8px;
	height: 18px;
	flex-shrink: 0;
}
.title-text {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	margin-left: 4px;
}

/* ===================================================================
   通知列表
   =================================================================== */
.notice-list {
	display: flex;
	flex-direction: column;
}

.notice-card {
	width: 1539px;
	// height: 92px;
	border: 0.5px solid #EBECEF;
	border-radius: 10px;
	display: flex;
	align-items: flex-start;
	padding: 24px;
	box-sizing: border-box;
	margin-bottom: 24px;
	transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	}
}
.notice-card:last-child {
	margin-bottom: 0;
}

/* ---- 图标 ---- */
.notice-icon-wrap {
	width: 44px;
	height: 44px;
	position: relative;
	flex-shrink: 0;
}
.icon-ring {
	width: 44px;
	height: 44px;
	display: block;
}
.icon-inner {
	width: 26px;
	height: 26px;
	position: absolute;
	left: 9px;
	top: 9px;
}

/* ---- 通知内容 ---- */
.notice-body {
	margin-left: 12px;
	flex: 1;
	overflow: hidden;
}
.notice-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 22px;
}
.notice-title-row {
	display: flex;
	align-items: center;
}
.notice-title {
	font-size: 16px;
	font-weight: 500;
	color: #333;
}
.notice-arrow {
	width: 8px;
	height: 8px;
	margin-left: 4px;
	flex-shrink: 0;
}
.notice-time {
	font-size: 12px;
	color: #999;
	font-weight: 400;
	flex-shrink: 0;
}

.notice-desc {
	font-size: 14px;
	color: #666;
	font-weight: 400;
	margin-top: 4px;
	line-height: 23px;
	// overflow: hidden;
	// text-overflow: ellipsis;
	// white-space: nowrap;
}

/* ===================================================================
   分页
   =================================================================== */
.pagination-wrap {
	display: flex;
	justify-content: center;
	margin-top: 32px;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #0096FF;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:hover {
	color: #0096FF;
}
</style>
